import React from 'react';
import PropTypes from 'prop-types';
import backgroundSideBar from '../../../images/backgroundSideBar.png';
import Menu from './Menu';
import CodeUseClaro from 'images/codeUseClaro.png';
import { Link } from 'react-router-dom';
import { useMediaPredicate } from 'react-media-hook';

import IconCodeUser from 'images/iconCodeUser.png';
import BackgroundOpened from 'images/UI_CODE_ONE_Elementos_Icon_over_menu_open_atend_colored.png';
import BackgroundClosed from 'images/UI_CODE_ONE_Elementos_Icon_over_menu_close_atend_colored.png';
import './Left.css';

function Left({ collapsed, canSearchTicket }) {
  const [moduleBg, setModuleBg] = React.useState(BackgroundClosed);

  const desktopMediaQuery = useMediaPredicate('(min-width: 992px)');

  function handleSideBarImage() {
    if (!desktopMediaQuery) {
      return;
    }
    if (collapsed) {
      setModuleBg(BackgroundClosed);
    } else {
      setModuleBg(BackgroundOpened);
    }
  }

  React.useEffect(() => {
    handleSideBarImage();
  }, []);

  React.useEffect(() => {
    handleSideBarImage();
  }, [collapsed]);

  return (
    <>
      <nav className={collapsed ? 'active' : ''} id="sidebar" style={{ background: `url(${backgroundSideBar})` }}>
      <div className="sidebar-content" style={{ background: `url(${moduleBg})` }}>
        <div className="sidebar-header">

          <h3 className="mt-2 sidebar-app-name">
          <Link to="/home">
                <img src={CodeUseClaro} className="sidebar-logo" alt="Sidebar logo" />
              </Link>

          </h3>
          <strong className="sidebar-app-name">
              <Link to="/home">
                <img alt="code user icon" src={IconCodeUser} />
              </Link>
            </strong>
        </div>
        <Menu canSearchTicket={canSearchTicket} />
        </div>
      </nav>
    </>
  );
}

Left.propTypes = {
  canSearchTicket: PropTypes.string,
  collapsed: PropTypes.bool
};

Left.defaultProps = {
  canSearchTicket: 'F',
  collapsed: false,
};

export default Left;
